import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation DiscardBrandTermsBatch($ids: [ID!]!) {
    discardBrandTermsBatch(ids: $ids)
  }
`;

export const discardBrandTermsBatch = ({ ids }) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { ids },
  }).then(({ data }) => getSingleProp(data));
};
